import * as accessibilityNotificationsActions from './accessibility-notifications.actions';

export const accessibilityNotificationsEmitter = {
  store: null,
  polite: (message) => addNotification(accessibilityNotificationsEmitter.store, message, 'polite'),
  assertive: (message) => addNotification(accessibilityNotificationsEmitter.store, message, 'assertive'),
  rude: (message) => addNotification(accessibilityNotificationsEmitter.store, message, 'rude'),
}

function addNotification(store, message, alertLevel) {
  const { dispatch } = store || {};
  return dispatch(accessibilityNotificationsActions.addNotification(message, alertLevel));
}



// WEBPACK FOOTER //
// src/common/accessibility-notifications/accessibility-notifications.emitter.js